import { render, staticRenderFns } from "./WebPartFormRunner.vue?vue&type=template&id=23810a54&scoped=true&"
import script from "./WebPartFormRunner.vue?vue&type=script&lang=js&"
export * from "./WebPartFormRunner.vue?vue&type=script&lang=js&"
import style0 from "./WebPartFormRunner.vue?vue&type=style&index=0&id=23810a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23810a54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23810a54')) {
      api.createRecord('23810a54', component.options)
    } else {
      api.reload('23810a54', component.options)
    }
    module.hot.accept("./WebPartFormRunner.vue?vue&type=template&id=23810a54&scoped=true&", function () {
      api.rerender('23810a54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartFormRunner.vue"
export default component.exports